import { FormEventUserObject } from "./typeDefinitions";

export class FormEvent {
  event: string;
  user : FormEventUserObject;

  constructor(event: string, userObject: FormEventUserObject) {
    this.event = event;
    this.user = userObject;
  }
}